import { Injectable } from '@angular/core';
import { AgricultureMapConstants, LAYER_TYPES } from 'src/app/main/constants/dims-map-constants';
import { isNullOrUndefined } from 'util';
import { HEATWAVE_LAYER_LIST, HEATWAVE_LEGEND_LIST, HEATWAVE_SCHOOL_LAYER_LIST } from './heatwave-map-constants';
import { HeatwaveDataService } from '../heatwave-data.service';
import { isEmptyObject } from 'jquery';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { UtilsService } from 'src/app/utils/utils.service';
import * as L from 'leaflet';
import { Subject, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeatwaveMapService {
  heatwaveData: any = {};
  districtHeatwaveData: any = {};
  activeGroup: any;
  gisMapComp: any;
  overallAccuracy:any;
  private alertSubscriptions: Subscription[] = [];
  private mapClickHandlers: { [key: string]: any } = {};
  private _callGen = 0;
  // _callGen of the load whose districtHeatwaveData is currently held
  private districtDataGen = -1;

  constructor(private dataSrv: HeatwaveDataService, private utilsSrv: UtilsService) { }

  async getSrcWiseLayers(gisMapComp: any) {
    const myGen = ++this._callGen;
    gisMapComp.legendList = {};
    gisMapComp.labelStrings = []
    gisMapComp.heatwavePlaybarChartData = [];
    gisMapComp.heatwavePlaybarChartMax = 0;
    gisMapComp.showThrobber = true;
    this.gisMapComp = gisMapComp
    let queryParams: any = gisMapComp['params'];
    gisMapComp.selectedSource = queryParams['source']
    const baseMapIndex = queryParams['locType'] === 'DISTRICT' ? 5 : 3;
    gisMapComp.getAndSetBaseLayers(baseMapIndex);    
    if (!isNullOrUndefined(queryParams) && Object.keys(queryParams).length > 0) {
      //    let layerList:any = {}
      // // let layerName = (queryParams['locType'] == 'COUNTRY' || queryParams['locType'] == 'STATE') ? 'District' : 'Block'
      // let layerName = this.getHeatwaveBoundaryLayerName(queryParams['locType'])
      // layerList[layerName + ' Boundary'] = HEATWAVE_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA][layerName + ' Boundary']

      // if (queryParams.locType == 'COUNTRY') {
      //   layerList['State Boundary'] = HEATWAVE_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA]['State Boundary']
      // }

      // if (queryParams.locType == 'STATE') {
      //   layerList['District Boundary'] = HEATWAVE_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA]['District Boundary']
      // }
      // DISTRICT/BLOCK toggle from the infobox (same viewType mechanism as Heat Index)
      const viewType = this.getHeatwaveViewType(queryParams)
      gisMapComp['selectedViewType'] = viewType
      let layerList:any = this.getBoundaryLayerList(queryParams, viewType)

      if (queryParams.locType != 'COUNTRY') {
        /*Adding mask layer */
        layerList = gisMapComp.gisdataService.addMaskLayer(layerList, queryParams, gisMapComp.params.component)
      }
      this.removeStaleBoundaryLayers(gisMapComp, layerList)

      let postData = this.dataSrv.getPostDataForHW(queryParams, 'forecast')
      let blockData = await this.getDistrictHWData(queryParams, postData)
      let actualpostData = this.dataSrv.getPostDataForHW(queryParams, 'observed')
      let actualData = await this.getActualData(queryParams, actualpostData)
      if (myGen !== this._callGen) {
        gisMapComp.showThrobber = false;
        return;
      }
      this.getTimeStampList(blockData, actualData)
      if (!isEmptyObject(blockData) && !isEmptyObject(actualData)) {
        this.heatwaveData = await this.dataSrv.formatMandalData(blockData, 'hwv', 'hwc', gisMapComp, actualData)
        // District polygons are styled from district data, so it must be loaded before the layer is drawn
        if (viewType === 'DISTRICT') {
          await this.loadDistrictHeatwaveData(queryParams, postData, actualpostData, gisMapComp)
          if (myGen !== this._callGen) {
            return;
          }
        }
        this.setHeatwavePlaybarChartData(gisMapComp, queryParams, viewType)
        this.addSrcWiseVectorLayers(layerList, gisMapComp, queryParams)
        this.addSrcWiseWMSLayers(layerList, gisMapComp, queryParams);
        // this.activeGroup = this.dataSrv.getCurrentDateInYYYYMMDDFormat()
        this.activeGroup = gisMapComp.activeGroup
        gisMapComp.otherOptions.onLocationClick = queryParams.locType == 'DISTRICT' ? false : true
        //  postData['cType'] = 'DISTRICT'
        // actualpostData['cType'] = 'DISTRICT'
        // let districtData = await this.getDistrictHWData(queryParams, postData)
        // let districtActualData = await this.getActualData(queryParams, actualpostData)
        // this.districtHeatwaveData = await this.dataSrv.formatMandalData(districtData, 'hwv', 'hwc', gisMapComp, districtActualData)


        if (viewType !== 'DISTRICT') {
          await this.loadDistrictHeatwaveData(queryParams, postData, actualpostData, gisMapComp)
        }
        if (myGen === this._callGen) {
          this.districtDataGen = myGen
          // User toggled DISTRICT/BLOCK while this load was in progress
          if (this.getHeatwaveViewType(gisMapComp.params) !== viewType) {
            this.switchAdminLevel(gisMapComp)
          }
        }
        this.updateHeaderCounts()
        
        // Clear previous subscriptions and listeners
        this.alertSubscriptions.forEach(sub => sub.unsubscribe());
        this.alertSubscriptions = [];
        
        if (gisMapComp && gisMapComp.map) {
          this.clearPopups(gisMapComp);
          const alertLayerNames = ['School Points', 'Anganwadi Points', 'Healthcare Points'];
          alertLayerNames.forEach(name => {
            if (this.mapClickHandlers[name]) {
              this.removeMapClickListener(gisMapComp.map, name);
            }
            if (gisMapComp.layers && gisMapComp.layers.overlaylayers && gisMapComp.layers.overlaylayers[name]) {
              const layer = gisMapComp.layers.overlaylayers[name];
              if (gisMapComp.map.hasLayer(layer)) {
                gisMapComp.map.removeLayer(layer);
              }
            }
          });
        }

        this.alertSubscriptions.push(this.utilsSrv.schoolCheckBoxClicked.subscribe(data => {
          if (!isNullOrUndefined(data)) {
            if (data) {
              let schoolLayerList:any = {}
              schoolLayerList['School Points'] = HEATWAVE_SCHOOL_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA]['School Points']
              this.addSrcWiseWMSLayers(schoolLayerList, gisMapComp, queryParams)
              this.handleMapClick(gisMapComp, queryParams, 'School Points')
            } else {
              this.clearPopups(gisMapComp);
              if (gisMapComp.layers && gisMapComp.layers.overlaylayers['School Points']) {
                let layer = gisMapComp.layers.overlaylayers['School Points'];
                if (gisMapComp.map.hasLayer(layer)) {
                  gisMapComp.map.removeLayer(layer);
                }
              }
              this.removeMapClickListener(gisMapComp.map, 'School Points');
            }
          }
        }));

        this.alertSubscriptions.push(this.utilsSrv.CheckBoxAngaClicked.subscribe(data => {
          if (!isNullOrUndefined(data)) {
            if (data) {
              let schoolLayerList:any = {}
              schoolLayerList['Anganwadi Points'] = HEATWAVE_SCHOOL_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA]['Anganwadi Points']
              this.addSrcWiseWMSLayers(schoolLayerList, gisMapComp, queryParams)
              this.handleMapClick(gisMapComp, queryParams, 'Anganwadi Points')
            } else {
              this.clearPopups(gisMapComp);
              if (gisMapComp.layers && gisMapComp.layers.overlaylayers['Anganwadi Points']) {
                let layer = gisMapComp.layers.overlaylayers['Anganwadi Points'];
                if (gisMapComp.map.hasLayer(layer)) {
                  gisMapComp.map.removeLayer(layer);
                }
              }
              this.removeMapClickListener(gisMapComp.map, 'Anganwadi Points');
            }
          }
        }));

        this.alertSubscriptions.push(this.utilsSrv.CheckBoxHealthCareClicked.subscribe(data => {
          if (!isNullOrUndefined(data)) {
            if (data) {
              let schoolLayerList:any = {}
              schoolLayerList['Healthcare Points'] = HEATWAVE_SCHOOL_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA]['Healthcare Points']
              this.addSrcWiseWMSLayers(schoolLayerList, gisMapComp, queryParams)
              this.handleMapClick(gisMapComp, queryParams, 'Healthcare Points')
            } else {
              this.clearPopups(gisMapComp);
              if (gisMapComp.layers && gisMapComp.layers.overlaylayers['Healthcare Points']) {
                let layer = gisMapComp.layers.overlaylayers['Healthcare Points'];
                if (gisMapComp.map.hasLayer(layer)) {
                  gisMapComp.map.removeLayer(layer);
                }
              }
              this.removeMapClickListener(gisMapComp.map, 'Healthcare Points');
            }
          }
        }));
        gisMapComp.showThrobber = false
      }
    }

    // this.addLayersToMap(queryParams, gisMapComp);
  }

  setHeatwavePlaybarChartData(gisMapComp: any, queryParams: any, countLocationType: string = 'BLOCK') {
    gisMapComp.heatwavePlaybarChartData = [];
    gisMapComp.heatwavePlaybarChartMax = 0;

    if (!queryParams) {
      return;
    }

  //      const chartPostData = this.getHeatwaveChartPostData(queryParams);
  //   if (!chartPostData) {
  //     return;
  //   }
  // //       await new Promise((resolve) => {
  // //     forkJoin(
  // //       this.dataSrv.getTableDistrictData(chartPostData.heatWaveCount),
  // //       this.dataSrv.getTableActualData(chartPostData.actualData)
  // //     ).subscribe((response: any) => {
  // //       // const chartWholeData: any = this.dataSrv.formatChartData(response[0], "Heat Wave Band", response[1]);
  // //         let mergedChartResponse = this.dataSrv.replaceForecastWithObserved(response[0], response[1])
  // //       const chartWholeData: any = this.dataSrv.formatChartData(mergedChartResponse, "Heat Wave Band", response[1]);
  // //       if (!chartWholeData || !chartWholeData[0] || !chartWholeData[2]) {
  // //         resolve(true);
  // //         return;
  // //       }

  // //       const chartObject = chartWholeData[0];
  // //       const labels: any[] = Array.isArray(chartWholeData[2]) ? chartWholeData[2] : [];
  // //       const chartData: any[] = labels.map((label: string) => {
  // //         const severe = Number(chartObject['SevereHeatwave'] && chartObject['SevereHeatwave'][label]) || 0;
  // //         const heatwave = Number(chartObject['Heatwave'] && chartObject['Heatwave'][label]) || 0;
  // //         return {
  // //           timeStamp: label,
  // //           severe,
  // //           heatwave,
  // //           total: severe + heatwave
  // //         };
  // //       });

  // //       gisMapComp.heatwavePlaybarChartData = chartData;
  // //       gisMapComp.heatwavePlaybarChartMax = chartData.length > 0
  // //         ? Math.max(...chartData.map((item: any) => item.total))
  // //         : 0;
  // //       resolve(true);
  // //     }, () => {
  // //       resolve(true);
  // //     });
  // //   });
  // // }

  // // getHeatwaveChartPostData(queryParams: any) {
  // //   const today = new Date();
  // //   const startTs = today.getTime() - (2 * 24 * 60 * 60 * 1000);
  // //   const endTs = queryParams['source'] != 'ECMWF' ? today.getTime() + (6 * 24 * 60 * 60 * 1000) : today.getTime() + (14 * 24 * 60 * 60 * 1000);
  // //   const hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;

  // //   if (queryParams['locType'] == 'COUNTRY') {
  // //     const countryUUID = queryParams['pUUID'] || '00cb31c7-2928-4e6d-adcc-443d478c90d6';
  // //     return {
  // //       heatWaveCount: {
  // //         component: "HEATWAVE",
  // //         sUUID: countryUUID,
  // //         pUUID: countryUUID,
  // //         pType: "COUNTRY",
  // //         cType: "STATE",
  // //         // countLocationType: "DISTRICT",
  // //         countLocationType: "BLOCK",
  // //         source: queryParams['source'],
  // //         startTs,
  // //         endTs
  // //       },
  // //       actualData: {
  // //         component: "HEATWAVE",
  // //         sUUID: countryUUID,
  // //         pUUID: countryUUID,
  // //         pType: "COUNTRY",
  // //         cType: "STATE",
  // //         // countLocationType: "DISTRICT",
  // //         countLocationType: "BLOCK",
  // //         startTs,
  // //         endTs: today.getTime() + (6 * 24 * 60 * 60 * 1000)
  // //       }
  // //     };
  // //   }

  // //   if (queryParams['locType'] == 'STATE') {
  // //     const stateUUID = queryParams['pUUID'];
  // //     const currentLevel: any = hie[hie.indexOf(queryParams['locType']) + 1];
  // //     const firstLevel: any = hie[hie.indexOf(queryParams['locType']) + 2];
  // //     return {
  // //       heatWaveCount: {
  // //         pUUID: stateUUID,
  // //         sUUID: stateUUID,
  // //         pType: queryParams['locType'],
  // //         cType: currentLevel,
  // //         component: "HEATWAVE",
  // //         countLocationType: firstLevel,
  // //         source: queryParams['source'],
  // //         startTs,
  // //         endTs
  // //       },
  // //       actualData: {
  // //         component: "HEATWAVE",
  // //         sUUID: stateUUID,
  // //         pUUID: stateUUID,
  // //         pType: queryParams['locType'],
  // //         cType: currentLevel,
  // //         countLocationType: firstLevel,
  // //         startTs,
  // //         endTs: today.getTime() + (6 * 24 * 60 * 60 * 1000)
  // //       }
  // //     };
  // //   }

  // //   return null;
  // // }

  //   await new Promise((resolve) => {
  //     forkJoin(
  //       this.dataSrv.getTableDistrictData(chartPostData.heatWaveCount),
  //       this.dataSrv.getTableActualData(chartPostData.actualData)
  //     ).subscribe((response: any) => {
  //       // Merge forecast and observed data more comprehensively
  //       const mergedData = this.mergeHeatwaveData(response[0], response[1]);
  //       const chartWholeData: any = this.dataSrv.formatChartData(mergedData, "Heat Wave Band", response[1]);
  //       if (!chartWholeData || !chartWholeData[0]) {
  //         resolve(true);
  //         return;
  //       }

  //       const chartObject = chartWholeData[0];
  //       // Use labelStrings as the master list to ensure perfect alignment with the play bar
  //       const labels: any[] = gisMapComp.labelStrings || [];
  //       const chartData: any[] = labels.map((labelObj: any) => {
  //         const label = labelObj.fullLabel;
  //         const severe = Number(chartObject['SevereHeatwave'] && chartObject['SevereHeatwave'][label]) || 0;
  //         const heatwave = Number(chartObject['Heatwave'] && chartObject['Heatwave'][label]) || 0;
  //         return {
  //           timeStamp: label,
  //           severe,
  //           heatwave,
  //           total: severe + heatwave,
  //           isForecast: labelObj.type === 'forecast'
  //         };
  //       });

  //       // console.log("HEATWAVE CHART DATA - Final Chart Data:", chartData);
  //       // console.log("HEATWAVE CHART DATA - Block Number:", gisMapComp.blockNumber);

  //       gisMapComp.heatwavePlaybarChartData = chartData;
  //       gisMapComp.heatwavePlaybarChartMax = chartData.length > 0
  //         ? Math.max(...chartData.map((item: any) => item.total))
  //         : 0;
  //       resolve(true);
  //     }, (error) => {
  //       // console.error("HEATWAVE CHART DATA - Error:", error);
  //       resolve(true);
  //     });
  //   });
  // }




    const hwData = countLocationType === 'DISTRICT' ? this.districtHeatwaveData : this.heatwaveData;
    if (!hwData || Object.keys(hwData).length === 0) {
      return;
    }

    const filteredData = this.dataSrv.filterByPName(hwData, queryParams);
    const labels: any[] = gisMapComp.labelStrings || [];

    const chartData: any[] = labels.map((labelObj: any) => {
      const ts = labelObj.groupName;
      let severe = 0, heatwave = 0, normal = 0;

      for (const uuid of Object.keys(filteredData)) {
        const uuidData = filteredData[uuid];
        if (!uuidData || !uuidData.table_data) continue;
        const td = uuidData.table_data[ts];
        if (!td || !td.cat) continue;

        switch (td.cat) {
          case 'severe_heat_waves': severe++; break;
          case 'heat_waves': heatwave++; break;
          case 'normal': normal++; break;
        }
      }

      return {
        timeStamp: labelObj.fullLabel,
        severe,
        heatwave,
        normal,
        total: severe + heatwave + normal,
        isForecast: labelObj.type === 'forecast'
      };
    });

    gisMapComp.heatwavePlaybarChartData = chartData;
    gisMapComp.heatwavePlaybarChartMax = chartData.length > 0
      ? Math.max(...chartData.map((item: any) => item.total))
      : 0;
  }

  mergeHeatwaveData(forecast: any[], observed: any[]) {
    // If forecast is empty, use observed only (and vice versa)
    if (!forecast || forecast.length === 0) return observed;
    if (!observed || observed.length === 0) return forecast;

    const merged = [...forecast];
    const forecastUuids = new Set(forecast.map(f => f.uuid));

    observed.forEach(obs => {
      if (forecastUuids.has(obs.uuid)) {
        const forecastState = merged.find(f => f.uuid === obs.uuid);
        const forecastTimeStamps = new Set(forecastState.table_data.map((t:any) => t.timeStamp));
        
        obs.table_data.forEach((obsData:any) => {
          if (!forecastTimeStamps.has(obsData.timeStamp)) {
            forecastState.table_data.push(obsData);
          } else {
            const index = forecastState.table_data.findIndex((t:any) => t.timeStamp === obsData.timeStamp);
            forecastState.table_data[index] = obsData;
          }
        });
        
        // Sorting table_data by timeStamp to ensure correct chart alignment
        forecastState.table_data.sort((a:any, b:any) => Number(a.timeStamp) - Number(b.timeStamp));
      } else {
        merged.push(obs);
      }
    });

    return merged;
  }

  getTodayWithShift() {
    const today = new Date();
    const currentHour = today.getHours();
    const currentMinutes = today.getMinutes();

    if (!(currentHour > 17 || (currentHour === 17 && currentMinutes >= 30))) {
      // Before 5:30 PM, shift "today" back by 1 day
      today.setDate(today.getDate() - 1);
    }
    return today;
  }

  getHeatwaveChartPostData(queryParams: any) {
    const today = this.getTodayWithShift();
    const startTs = today.getTime() - (2 * 24 * 60 * 60 * 1000);
    const endTs = queryParams['source'] != 'ECMWF' ? today.getTime() + (10 * 24 * 60 * 60 * 1000) : today.getTime() + (50 * 24 * 60 * 60 * 1000);
    const hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;

    // console.log("HEATWAVE CHART DATA - Date Range:", { 
    //   today: today.toLocaleDateString(), 
    //   startTs: new Date(startTs).toLocaleDateString(), 
    //   endTs: new Date(endTs).toLocaleDateString(),
    //   source: queryParams['source']
    // });

    if (queryParams['locType'] == 'COUNTRY') {
      const countryUUID = queryParams['pUUID'] || '00cb31c7-2928-4e6d-adcc-443d478c90d6';
      return {
        heatWaveCount: {
          component: "HEATWAVE",
          sUUID: countryUUID,
          pUUID: countryUUID,
          pType: "COUNTRY",
          cType: "STATE",
          // countLocationType: "DISTRICT",
          countLocationType: "BLOCK",
          source: queryParams['source'],
          startTs,
          endTs
        },
        actualData: {
          component: "HEATWAVE",
          sUUID: countryUUID,
          pUUID: countryUUID,
          pType: "COUNTRY",
          cType: "STATE",
          // countLocationType: "DISTRICT",
          countLocationType: "BLOCK",
          startTs,
          endTs: today.getTime() + (6 * 24 * 60 * 60 * 1000)
        }
      };
    }

    if (queryParams['locType'] == 'STATE') {
      const stateUUID = queryParams['pUUID'];
      //  const currentLevel: any = hie[hie.indexOf(queryParams['locType']) + 1];
      // const firstLevel: any = hie[hie.indexOf(queryParams['locType']) + 2];
      return {
        heatWaveCount: {
          pUUID: stateUUID,
          sUUID: stateUUID,
          pType: "STATE",
          cType: "DISTRICT",
          component: "HEATWAVE",
          countLocationType: "BLOCK",
          source: queryParams['source'],
          startTs,
          endTs
        },
        actualData: {
          component: "HEATWAVE",
          sUUID: stateUUID,
          pUUID: stateUUID,
          pType: "STATE",
          cType: "DISTRICT",
          countLocationType: "BLOCK",
          startTs,
          endTs: today.getTime() + (6 * 24 * 60 * 60 * 1000)
        }
      };
    }

    return null;
  }

  clearPopups(gisMapComp: any) {
    if (gisMapComp && gisMapComp.map) {
      gisMapComp.map.closePopup();
      // Aggressive cleanup: remove any popup layers manually too
      gisMapComp.map.eachLayer((layer:any) => {
        if (layer instanceof L.Popup) {
          gisMapComp.map.removeLayer(layer);
        }
      });
    }
  }

  removeMapClickListener(map: L.Map, layerName: string) {
    if (this.mapClickHandlers[layerName]) {
      map.off('click', this.mapClickHandlers[layerName]);
      delete this.mapClickHandlers[layerName];
    }
  }

  handleMapClick(gisMapComp: any, queryParams: any, layerName:any) {
    this.removeMapClickListener(gisMapComp.map, layerName);

    const clickHandler = (e: L.LeafletMouseEvent) => {
      if (gisMapComp.layers.overlaylayers.hasOwnProperty(layerName)) {
        let layer = gisMapComp.layers.overlaylayers[layerName]
        this.dataSrv.getFeatureInfo(e.latlng, layer, gisMapComp.map).subscribe((res: any) => {
          const latlng = e.latlng;
          let content: any = null;
          if (layerName == 'School Points') {
            content = this.setHtmlContentForSchoolAlert(res, gisMapComp, queryParams)
          } else if (layerName == 'Anganwadi Points') {
            content = this.setHtmlContentForAnganwadiAlert(res, gisMapComp, queryParams)
          } else if (layerName == 'Healthcare Points') {
            content = this.setHtmlContentForHealthCareAlert(res, gisMapComp, queryParams)
          }

          if (content != null) {
            this.clearPopups(gisMapComp);
            L.popup({
              pane: 'measuretool'
            })
              .setLatLng(latlng)
              .setContent(content)
              .addTo(gisMapComp.map);
          }
        });
      }
    };

    this.mapClickHandlers[layerName] = clickHandler;
    gisMapComp.map.on('click', clickHandler);
  }

  async addSrcWiseWMSLayers(layerList: any, gisMapComp: any, queryParams: any) {
    let wmsLayersBasedOnView = gisMapComp.gisdataService.getApplicationBasedLayer(layerList, LAYER_TYPES.WMS_LAYER);
    wmsLayersBasedOnView = this.addSourceWiseLayers(gisMapComp, wmsLayersBasedOnView, queryParams);
    for (let layer in layerList) {
      if (layerList[layer].applycql_filter) {
        wmsLayersBasedOnView = this.formatWmsLayersData(wmsLayersBasedOnView, queryParams);
      }
    }
    gisMapComp.addSrcWiseWMSLayers(wmsLayersBasedOnView);
  }

  formatWmsLayersData(layerList: any, queryParams?: any) {
    if (!isNullOrUndefined(queryParams)) {
      for (let layerName in layerList) {
        // if(layerName != 'Farm Polygons'){
        //   if (layerList[layerName].layerOptions.name == 'Canals' || layerList[layerName].layerOptions.name == 'Canals Labels' || layerList[layerName].layerOptions.name == 'Stream' || layerList[layerName].layerOptions.name == 'Rivers' || layerList[layerName].layerOptions.name == 'Rivers Labels') {
        //     layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value
        //   } 
        //   else {
        let uuid: any = queryParams.pUUID;
        //      if(layerName == 'Krishibhavan Boundaries Labels') {
        //       layerList[layerName].layerOptions.cql_filter_value = null
        //     }
        //     if(queryParams.locType != 'KRISHIBHAVAN'){
        //       // layerList[layerName].layerOptions.cql_filter_value = locTypeVsUUID[queryParams.locType]//'district_uuid'
        //         // layerList[layerName].layerOpt  ions.visible = true
        //     }
        //     else if(queryParams.locType == 'KRISHIBHAVAN') {
        //       if(layerName == 'Krishibhavan Boundaries Labels') {
        //         layerList[layerName].layerOptions.cql_filter_value = 'kb_uuid'
        //         layerList[layerName].layerOptions.visible = true
        //       }
        //     }
        if (queryParams.locType == 'DISTRICT') {
          let allLocations = queryParams.location.split('&')
          let districtUUID = allLocations[2].split('##')[1]
          if (layerList[layerName].layerOptions.cql_filter_value) {
            layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + districtUUID + "'";
          }
        }
        //   }
        // }
        if (layerName.includes('world_view')) {
          let uuid: any = queryParams.pUUID;
          if (!isNullOrUndefined(queryParams.type)) {
            layerList[layerName].layerOptions.cql_filter = queryParams.locType == 'VILLAGE' ? '1=1;village_uuid' + "='" + uuid + "'" : '1=1;' + AgricultureMapConstants.LOCTYPE_CQLFILTERVALUE[queryParams.locType] + "='" + uuid + "'";
          } else {
            layerList[layerName].layerOptions.cql_filter = '1=1;' + AgricultureMapConstants.LOCTYPE_CQLFILTERVALUE[queryParams.locType] + "='" + uuid + "'";
          }
        }
      }
      return layerList;
    }
  }

  getDistrictHWData(queryParams:any, postData:any) {
    return new Promise((resolve, reject) => {
      this.dataSrv.getDistrictData(postData).subscribe(data => {
        resolve(data)
      })
    })
  }

  getActualData(queryParams:any, postData:any) {
    return new Promise((resolve, reject) => {
      this.dataSrv.getActualData(postData).subscribe(data => {
        resolve(data)
      })
    })
  }

  getTimeStampList(districtData:any, actualData:any) {
    const timeStampSet = new Set();
    for (const locName of Object.keys(districtData)) {
      if (districtData[locName]['table_data'] == null || districtData[locName]['table_data'] == undefined) {
        continue;
      }
      for (const index of districtData[locName]['table_data']) {
        timeStampSet.add(index['timeStamp']);
      }
    }
    for (const locName of Object.keys(actualData)) {
      if (actualData[locName]['table_data'] == null || actualData[locName]['table_data'] == undefined) {
        continue;
      }
      for (const index of actualData[locName]['table_data']) {
        timeStampSet.add(index['timeStamp']);
      }
    }
    this.dataSrv.combinedTimeStampList = Array.from(timeStampSet);
  }

  async addSrcWiseVectorLayers(layerList: any, gisMapComp: any, queryParams: any, fitBounds: boolean = true) {
    let vectorLayersBasedOnView = gisMapComp.gisdataService.getApplicationBasedLayer(layerList, LAYER_TYPES.VECTOR_LAYER);
    vectorLayersBasedOnView = this.addSourceWiseLayers(gisMapComp, vectorLayersBasedOnView, queryParams);
    for (let layer in layerList) {
      if (layerList[layer].applycql_filter) {
        vectorLayersBasedOnView = this.formatVectorLayersData(vectorLayersBasedOnView, queryParams, gisMapComp);
      }
    }
    // this.removeCurrentLevelBoundaryLayer(gisMapComp);
    this.setVectorLayerStyles(vectorLayersBasedOnView, gisMapComp, this.getActiveHeatwaveData(queryParams));
    gisMapComp.addSrcWiseVECTORLayers(vectorLayersBasedOnView);
    // gisMapComp.fitBoundsForCurrentLocation(queryParams);
    if (fitBounds) {
      gisMapComp.fitBoundsForCurrentLocation(queryParams);
    }
    this.addLegend(gisMapComp)
  }

  addLegend(gisMapComp:any) {
    for (const key in HEATWAVE_LEGEND_LIST[AgricultureMapConstants.LOCATIONS.INDIA]) {
      gisMapComp['legendList'][key] = HEATWAVE_LEGEND_LIST[AgricultureMapConstants.LOCATIONS.INDIA][key];
    }
    gisMapComp.manageLegend();
  }

  addSourceWiseLayers(gisMapComp: any, layerList?: any, params?: any, queryParams?: any) {
    let currTs: any = new Date().getTime();
    let layers: any = {};
    for (var i in layerList) {
      layers[i] = layerList[i];
      gisMapComp.activeLayers[i] = layerList[i].layerOptions.visible;
    }
    return layers;
  }
  getHeatwaveBoundaryLayerName(locType: string, viewType: string = 'BLOCK') {
    // Country and State follow the DISTRICT/BLOCK toggle; District level always shows blocks.
    //  if (locType == 'COUNTRY' || locType == 'STATE') {
    //   return 'Block';
    // }
    if ((locType == 'COUNTRY' || locType == 'STATE') && viewType == 'DISTRICT') {
      return 'District';
    }

    return 'Block';
  }

  getHeatwaveViewType(params: any) {
    if (!params || params['locType'] == 'DISTRICT') {
      return 'BLOCK';
    }
    return params['viewType'] == 'DISTRICT' ? 'DISTRICT' : 'BLOCK';
  }

  getActiveHeatwaveData(params: any) {
    return this.getHeatwaveViewType(params) == 'DISTRICT' ? this.districtHeatwaveData : this.heatwaveData;
  }

  getBoundaryLayerList(queryParams: any, viewType: string) {
    const layers = HEATWAVE_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA];
    let layerList: any = {}
    let layerName = this.getHeatwaveBoundaryLayerName(queryParams['locType'], viewType)
    layerList[layerName + ' Boundary'] = layers[layerName + ' Boundary']

    if (queryParams.locType == 'COUNTRY') {
      layerList['State Boundary'] = layers['State Boundary']
    }

    if (queryParams.locType == 'STATE') {
      layerList['District Boundary'] = layers['District Boundary']
    }
    return layerList
  }

  // Remove Block/District boundary layers that are no longer part of the current view
  // (same approach as HeatindexMapService.getSrcWiseLayers)
  removeStaleBoundaryLayers(gisMapComp: any, layerList: any) {
    const boundaryKeys = ['Block Boundary', 'District Boundary'];
    if (gisMapComp.layers && gisMapComp.layers.overlaylayers) {
      for (const key of boundaryKeys) {
        if (!layerList[key] && gisMapComp.layers.overlaylayers[key]) {
          if (gisMapComp.map && gisMapComp.map.hasLayer(gisMapComp.layers.overlaylayers[key])) {
            gisMapComp.map.removeLayer(gisMapComp.layers.overlaylayers[key]);
          }
          delete gisMapComp.layers.overlaylayers[key];
        }
      }
    }
  }

  async loadDistrictHeatwaveData(queryParams: any, postData: any, actualpostData: any, gisMapComp: any) {
    postData['cType'] = 'DISTRICT'
    actualpostData['cType'] = 'DISTRICT'
    let districtData = await this.getDistrictHWData(queryParams, postData)
    let districtActualData = await this.getActualData(queryParams, actualpostData)
    this.districtHeatwaveData = await this.dataSrv.formatMandalData(districtData, 'hwv', 'hwc', gisMapComp, districtActualData)
  }

  // Called on DISTRICT/BLOCK toggle. Block and district data are both already loaded by
  // getSrcWiseLayers, so only the boundary layers are swapped: no data API calls, and the
  // selected date, source and location stay as they are.
  switchAdminLevel(gisMapComp: any) {
    const queryParams = gisMapComp.params;
    if (isNullOrUndefined(queryParams) || this.districtDataGen !== this._callGen) {
      // Still loading; getSrcWiseLayers applies the new level once district data is ready
      return;
    }
    const viewType = this.getHeatwaveViewType(queryParams);
    gisMapComp['selectedViewType'] = viewType;
    const layerList = this.getBoundaryLayerList(queryParams, viewType);
    this.removeStaleBoundaryLayers(gisMapComp, layerList);
    // State Boundary is unaffected by the toggle; re-add only the block/district layers so their styling is rebuilt
    delete layerList['State Boundary'];
    this.addSrcWiseVectorLayers(layerList, gisMapComp, queryParams, false);
    // Re-apply the selected date's colours to the new layer, as a play bar tick does
    this.changeTimeLayers(gisMapComp, gisMapComp.activeGroup);
  }

  // removeCurrentLevelBoundaryLayer(gisMapComp: any) {
  //   const levelBoundary = gisMapComp.gisUtils.titleCase(gisMapComp.queryParams.params.locType) + ' ' + 'Boundaries';
  //   gisMapComp.map.eachLayer((layer: any) => {
  //     if (layer.options.layer_name === levelBoundary && gisMapComp.map.hasLayer(layer)) {
  //       gisMapComp.map.removeLayer(layer);
  //     }
  //   });
  // }

  getFeatureUUID(properties: any, currentLevel: string) {
    if (currentLevel == 'DISTRICT') {
      return properties['uuid'] || properties['dist_uuid'] || properties['dist_uuid'];
    }

    if (currentLevel == 'BLOCK') {
      return properties['uuid'] || properties['block_uuid'] || properties['uuid_block'] || properties['uuid_manda'];
    }

    return properties['uuid'] || properties['state_uuid'] || properties['state_uuid'];
  }

  getHeatwaveDataByUUID(hwData: any, uuid: any) {
    if (isNullOrUndefined(uuid) || isNullOrUndefined(hwData)) {
      return null;
    }

    const lowerUUID = typeof uuid === 'string' ? uuid.toLowerCase() : uuid;
    const upperUUID = typeof uuid === 'string' ? uuid.toUpperCase() : uuid;

    return hwData[uuid] || hwData[lowerUUID] || hwData[upperUUID] || null;
  }

  formatVectorLayersData(layerList: any, queryParams?: any, gisMapComp?: any) {
    if (!isNullOrUndefined(queryParams)) {
      for (let layerName in layerList) {
        let uuid: any = queryParams['pUUID'];
        // if (layerName == 'Krishibhavan') {
        //   layerList[layerName].layerOptions.cql_filter_value = null
        // }
        // if (layerName == 'Krishibhavan') {
        //   layerList[layerName].layerOptions.cql_filter_value = 'state_uuid';
        // }
        // if (layerList[layerName].layerOptions.cql_filter_value) {
        //   layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + uuid + "'";
        // }
        if (queryParams.locType == 'COUNTRY' && layerName == 'District Boundary') {
          layerList[layerName].layerOptions.cql_filter_value = null
          layerList[layerName].layerOptions.cql_filter = '1=1';
        }
        if (queryParams.locType == 'COUNTRY' && layerName == 'Block Boundary') {
          layerList[layerName].layerOptions.cql_filter_value = null
          layerList[layerName].layerOptions.cql_filter = '1=1';
        }
        if (queryParams['locType'] == 'STATE' && layerName == 'District Boundary') {
          layerList[layerName].layerOptions.cql_filter_value = 'state_uuid'
          layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + uuid + "'";
        }
        if (queryParams['locType'] == 'STATE' && layerName == 'Block Boundary') {
          layerList[layerName].layerOptions.cql_filter_value = 'state_uuid'
          layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + uuid + "'";
        }
        if (queryParams['locType'] == 'DISTRICT' && layerName == 'Block Boundary') {
          layerList[layerName].layerOptions.cql_filter_value = 'dist_uuid'
          layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + uuid + "'";
        }
      }
      return layerList;
    }
  }

  //  setVectorLayerStyles(layerList: any, gisMapComp: any, hwData) {
  //   for (let key in layerList) {
  //     let layerName = layerList[key]['layerOptions']['layerName'].split(':')[1];
  //     layerList[key].layerOptions.vectorTileLayerStyles[layerName] = function (properties: any) {
  //       let hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
  //       let currentLevel: any = hie[hie.indexOf(gisMapComp.queryParams.params.locType) + 1];
  //       let levelBoundary = gisMapComp.gisUtils.titleCase(gisMapComp.queryParams.params.locType) + ' ' + 'Boundaries';
  //       gisMapComp.map.eachLayer((layer: any) => {
  //         if (layer.options.layer_name === levelBoundary) {
  //           if (gisMapComp.map.hasLayer(layer)) {
  //             gisMapComp.map.removeLayer(layer);
  //           }
  //         }
  //       });
  //       let nextLevelUUID;
  //       if (currentLevel == 'DISTRICT') {
  //         nextLevelUUID = 'State_UUID';
  //       } else if (currentLevel == 'BLOCK') {
  //         nextLevelUUID = 'Dist_UUID'
  //       } else {
  //         nextLevelUUID = 'UUID'
  //       }
  //       let locUUID: any
  //       if (currentLevel == 'DISTRICT') {
  //         locUUID = properties['State_UUID'];
  //       } else if (currentLevel == 'BLOCK') {
  //         locUUID = properties['UUID'];
  //       } else {
  //         locUUID = properties[nextLevelUUID];
  //       }
  //       let style: any;
  //       if (!isNullOrUndefined(hwData[properties['UUID']])) {
  //         style = {
  //           color: '#000000',
  //           fill: true,
  //           weight: 0.25,
  //           fillColor: ProjConstants.HEAT_WATCHES_LEGEND[hwData[properties['UUID']]['table_data'][gisMapComp.activeGroup]['cat']],
  //           fillOpacity: 0.8
  //         }
  //       } else {
  //         style = {
  //           color: '#000000',
  //           fill: false,
  //           weight: 1,
  //           opacity: 1,
  //           fillColor: 'transparent',
  //           fillOpacity: 0.5
  //         }
  //       }
  //       return style
  //     }
  //   }
  // }

  setVectorLayerStyles(layerList: any, gisMapComp: any, hwData:any) {
    const self = this;
    for (let key in layerList) {
      let vectLayerName = layerList[key]['layerOptions']['layerName'].split(':')[1];
      let styleLevel = (key.includes('Block')) ? 'BLOCK' : 'DISTRICT';
      layerList[key].layerOptions.getFeatureId = function (feature: any) {
        return self.getFeatureUUID(feature.properties, styleLevel);
      };
      layerList[key].layerOptions.vectorTileLayerStyles[vectLayerName] = function (properties: any) {
        let hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
        // let currentLevel: any = hie[hie.indexOf(gisMapComp.params.locType) + 1];
        //  let styleLevel = (key.includes('Block')) ? 'BLOCK' : 'DISTRICT';
        //  const featureUUID = properties['uuid']//self.getFeatureUUID(properties, styleLevel);
        const featureUUID = self.getFeatureUUID(properties, styleLevel);
        const featureHeatwaveData = self.getHeatwaveDataByUUID(hwData, featureUUID);
        let levelBoundary = gisMapComp.gisUtils.titleCase(gisMapComp.params.locType) + ' ' + 'Boundaries';
        gisMapComp.map.eachLayer((layer: any) => {
          if (layer.options.layer_name === levelBoundary) {
            if (gisMapComp.map.hasLayer(layer)) {
              gisMapComp.map.removeLayer(layer);
            }
          }
        });
        // let nextLevelUUID;
        // if (styleLevel == 'DISTRICT') {
        //   nextLevelUUID = 'State_UUID';
        // } else if (styleLevel == 'BLOCK') {
        //   nextLevelUUID = 'Dist_UUID'
        // } else {
        //   nextLevelUUID = 'UUID'
        // }
        // let locUUID: any
        // if (styleLevel == 'DISTRICT') {
        //   locUUID = properties['State_UUID'];
        // } else if (styleLevel == 'BLOCK') {
        //   locUUID = properties['UUID'];
        // } else {
        //   locUUID = properties[nextLevelUUID];
        // }
        let style: any;
        if (!isNullOrUndefined(featureHeatwaveData) && featureHeatwaveData['table_data'] && featureHeatwaveData['table_data'][gisMapComp.activeGroup]) {
          style = {
            color: '#000000',
            fill: true,
            weight: gisMapComp.params.locType == 'COUNTRY' ? 0.08 : 0.20,
            fillColor: ProjConstants.HEAT_WATCHES_LEGEND[featureHeatwaveData['table_data'][gisMapComp.activeGroup]['cat']],
            // fillOpacity: (gisMapComp.params.locType == 'STATE' && styleLevel == 'BLOCK') ? 0.5 : 0.8
            fillOpacity: 0.8
            //   }
            // } else {
            //   if (gisMapComp.params.locType == 'STATE' && styleLevel == 'DISTRICT') {
            //     style = {
            //       color: '#000000',
            //       fill: false,
            //       weight: 1.5,
            //       opacity: 1
          }
        } else {
          style = {
            color: '#000000',
            fill: false,
            weight: gisMapComp.params.locType == 'COUNTRY' ? 0.5 : 0.2,
            opacity: 1,
            fillColor: 'transparent',
            fillOpacity: 0.5
            // }
          }
        }
        return style
      }
    }
  }


  changeTimeLayers(gis:any, groupName:any) {    
    // if (groupName != gis.activeGroup) {
    gis.activeGroup = groupName;
    this.activeGroup = groupName
    let layerList = gis.layers.overlaylayers;
    // for(let key in gis.activeLayers) {
    // let layerName = (gis.queryParams.params.locType == 'COUNTRY' || gis.queryParams.params.locType == 'STATE') ? 'District' : 'Block'
    let layerName = this.getHeatwaveBoundaryLayerName(gis.params.locType, this.getHeatwaveViewType(gis.params))
    let layer = layerList[layerName + ' Boundary']
      // if (layer['options']['type'] == 'VECTOR') {
      // // let layerName = layer['options']['layerName'].split(':')[1]
      // for (const uuid of Object.keys(this.heatwaveData)) {
      //   let color = '#AAAAAA';
      //   if (this.heatwaveData[uuid] && this.heatwaveData[uuid]['table_data'][groupName]) {
      //     color = ProjConstants.HEAT_WATCHES_LEGEND[this.heatwaveData[uuid]['table_data'][groupName]['cat']];
      //   }

    const hwData = this.getActiveHeatwaveData(gis.params)
    if (layer && layer['options']['type'] == 'VECTOR') {
      // let layerName = layer['options']['layerName'].split(':')[1]
      for (const uuid of Object.keys(hwData)) {
        let color = '#AAAAAA';
        if (hwData[uuid] && hwData[uuid]['table_data'][groupName]) {
          color = ProjConstants.HEAT_WATCHES_LEGEND[hwData[uuid]['table_data'][groupName]['cat']];
        }
        const style = {
          fill: true,
          // weight: 0.1,
          weight: gis.params.locType == 'COUNTRY' ? 0.08 : 0.20,
          color: '#000000',
          fillColor: color,
          fillOpacity: 0.8,
          // fillOpacity: (gis.params.locType == 'STATE' && layerName == 'Block') ? 0.5 : 0.8,
        };
        layer.setFeatureStyle(uuid, style);
      }
    }
    this.updateHeaderCounts()
    this.gisMapComp.gisUtils.setTimeStamp(groupName);
  }

  handleAdminPolygons(layer: any, mapObj: any, params: any, gisMapComp: any) {
    layer.setStyle({
      color: '#000000',
      fill: false,
      weight: 1.5,
    });
  }


  setHtmlContentForSchoolAlert(res: any, gisMapComp: any, queryParams: any) {
    let allLocations = queryParams.location.split('&')
    let districtUUID = allLocations[2].split('##')[1]
    if (res && res.features[0] && res.features[0].properties.Dist_UUID == districtUUID) {
      let UUID = res.features[0].properties.Block_UUID;
      let tableDataObject = this.heatwaveData[UUID];
      let tableData:any = {};
      if (tableDataObject) {
        tableData = { ...tableDataObject.table_data };
      }
      let specificDate = gisMapComp.selectedTimeStamp;
      let catValue
      if (tableData[specificDate]) {
        catValue = tableData[specificDate].cat;
      }
      let State_Name = res.features[0].properties.State_Name;
      let Dist_Name = res.features[0].properties.Dist_Name;
      let Block_Name = res.features[0].properties.Block_Name;
      let vilname = res.features[0].properties.vilname;
      let schname = res.features[0].properties.schname;
      let school_typ = res.features[0].properties.school_typ;
      let school_cat = res.features[0].properties.school_cat;
      let schcd = res.features[0].properties.schcd;
      let latitude = res.features[0].properties.latitude;
      let longitude = res.features[0].properties.longitude;
      let pincode = res.features[0].properties.pincode;

      var htmlString = "<html><body>";
      htmlString += '<div class="popup-table-section inflowClickPopup">';
      htmlString += `<div class="card-body p-0">
                 <table class="table table-sm m-0 table-bordered table-striped">`;
      htmlString += `<tbody>
       <tr>
            <th>School Name</th>
            <td>${schname ? schname : '-'}</td>
          </tr>  
          <tr>
            <th>School Type</th>
            <td>${school_typ ? school_typ : '-'}</td>
          </tr>  
          <tr>
            <th>School category</th>
            <td>${school_cat ? school_cat : '-'}</td>
          </tr>  
          <tr>
            <th>School code</th>
            <td>${schcd ? schcd : '-'}</td>
          </tr>  
          <tr>
            <th>State</th>
            <td>${State_Name ? State_Name : '-'}</td>
          </tr>
          <tr>
            <th>District</th>
            <td>${Dist_Name ? Dist_Name : '-'}</td>
          </tr>  
          <tr>
            <th>Block</th>
            <td>${Block_Name ? Block_Name : '-'}</td>
          </tr>  
          <tr>
            <th>Village</th>
            <td>${vilname ? vilname : '-'}</td>
          </tr>  
          <tr>
            <th>Pincode</th>
            <td>${pincode ? pincode : '-'}</td>
          </tr>       
          <tr>
            <th>Latitude</th>
            <td>${latitude ? latitude : '-'}</td>
          </tr>  
          <tr>
            <th>Longitude</th>
            <td>${longitude ? longitude : '-'}</td>
          </tr>  
          <tr>
            <th>School Alert</th>
            <td>${catValue ? catValue : '-'}</td>
          </tr>  
          </table>
     </div>
     </div>`;
      return htmlString;

    } else {
      return null
    }
  }

  setHtmlContentForAnganwadiAlert(res: any, gisMapComp: any, queryParams:any) {
    let allLocations = queryParams.location.split('&')
    let districtUUID = allLocations[2].split('##')[1]
    if (res.features[0].properties.dist_uuid == districtUUID) {
      let UUID = res.features[0].properties.uuid_manda;
      let tableDataObject = this.heatwaveData[UUID];
      let tableData:any = {};
      if (tableDataObject) {
        tableData = { ...tableDataObject.table_data };
      }
      let specificDate = gisMapComp.selectedTimeStamp;
      let catValue
      if (tableData[specificDate]) {
        catValue = tableData[specificDate].cat;
      }
      let Mandal_name = res.features[0].properties.mname;
      let Sector_name = res.features[0].properties.sec_name;
      let awc_id = res.features[0].properties.awc_id;
      let awc_name = res.features[0].properties.awc_name;
      var htmlString = "<html><body>";
      htmlString += '<div class="popup-table-section inflowClickPopup">';
      htmlString += `<div class="card-body p-0">
         <table class="table table-sm m-0 table-bordered table-striped">`;
      htmlString += `<tbody>
       <tr>
            <th>Mandal Name</th>
            <td>${Mandal_name ? Mandal_name : '-'}</td>
          </tr>  
          <tr>
            <th>awc_id</th>
            <td>${awc_id ? awc_id : '-'}</td>
          </tr>  
          <tr>
            <th>awc_name</th>
            <td>${awc_name ? awc_name : '-'}</td>
          </tr>  
          <tr>
            <th>Anganwadi Alert</th>
            <td>${catValue ? catValue : '-'}</td>
          </tr>  
          </table>
     </div>
     </div>`;
      return htmlString;

    } else {
      return null
    }
  }

  setHtmlContentForHealthCareAlert(res: any, gisMapComp: any, queryParams:any) {
    let allLocations = queryParams.location.split('&')
    let districtUUID = allLocations[2].split('##')[1]
    if (res.features[0].properties.dist_uuid == districtUUID) {
      let UUID = res.features[0].properties.uuid_block;
      let tableDataObject = this.heatwaveData[UUID];
      let tableData:any = {};
      if (tableDataObject) {
        tableData = { ...tableDataObject.table_data };
      }
      let specificDate = gisMapComp.selectedTimeStamp;
      let catValue
      if (tableData[specificDate]) {
        catValue = tableData[specificDate].cat;
      }



      let id = res.features[0].properties.objectid;
      let State_Name = res.features[0].properties.state;
      let Dist_Name = res.features[0].properties.district;
      let subdistrict = res.features[0].properties.subdistric;
      let locality = res.features[0].properties.locality;
      let landmark = res.features[0].properties.landmark;
      let facility = res.features[0].properties.facilityty;

      var htmlString = "<html><body>";
      htmlString += '<div class="popup-table-section inflowClickPopup">';
      htmlString += `<div class="card-body p-0">
         <table class="table table-sm m-0 table-bordered table-striped">`;
      htmlString += `<tbody> 
          <tr>
            <th>State</th>
            <td>${State_Name ? State_Name : '-'}</td>
          </tr>
          <tr>
            <th>District</th>
            <td>${Dist_Name ? Dist_Name : '-'}</td>
          </tr>  
          <tr>
            <th>Sub District</th>
            <td>${subdistrict ? subdistrict : '-'}</td>
          </tr>  
          <tr>
            <th>Locality</th>
            <td>${locality ? locality : '-'}</td>
          </tr>  
          <tr>
            <th>Landmark</th>
            <td>${landmark ? landmark : '-'}</td>
          </tr>       
          <tr>
            <th>Facility</th>
            <td>${facility ? facility : '-'}</td>
          </tr>  
          <tr>
            <th>ID</th>
            <td>${id ? id : '-'}</td>
          </tr>  
          <tr>
            <th>HealthCare Alert</th>
            <td>${catValue ? catValue : '-'}</td>
          </tr>  
          </table>
     </div>
     </div>`;
      return htmlString;

      // } else {
      //   return null
    }
  }

  updateHeaderCounts() {
    let locWiseCountMap:any = {}
    let severeheatWave = 0;
    let heatWave = 0;
    let normal = 0;
    let severeheatWaveforDistrict = 0;
    let heatWaveforDistrict = 0;
    let normalforDistrict = 0;
    // let accuracy = 0;
    let queryParams = this.gisMapComp['params']
    // const heatwaveData = this.dataSrv.filterByPName(this.heatwaveData, queryParams)
    const heatwaveData = this.dataSrv.filterByPName(this.heatwaveData, queryParams)
    const districtHeatwaveData = this.dataSrv.filterByPName(this.districtHeatwaveData, queryParams)
    // console.log(heatwaveData,"heatwavedataaa");
    for (const uuid of Object.keys(heatwaveData)) {
      // console.log("checking updateHeaderCounts");
      const uuidData = heatwaveData[uuid];
      if (!uuidData || !uuidData.table_data) {
        continue;
      }

      const td = uuidData.table_data[this.activeGroup];
      if (!td || !td.cat) {
        continue;
      }

      switch (td.cat) {
        case 'severe_heat_waves':
          severeheatWave++;
          break;

        case 'heat_waves':
          heatWave++;
          break;

        case 'normal':
          normal++;
          break;

        // case 'accuracy':
        //   accuracy++;
        //   break;
      }
    }

    for (const uuid of Object.keys(districtHeatwaveData)) {
      // console.log("checking updateHeaderCounts");
      const uuidData = districtHeatwaveData[uuid];
      if (!uuidData || !uuidData.table_data) {
        continue;
      }

      const td = uuidData.table_data[this.activeGroup];
      if (!td || !td.cat) {
        continue;
      }

      switch (td.cat) {
        case 'severe_heat_waves':
          severeheatWaveforDistrict++;
          break;

        case 'heat_waves':
          heatWaveforDistrict++;
          break;

        case 'normal':
          normalforDistrict++;
          break;

        // case 'accuracy':
        //   accuracy++;
        //   break;
      }
    }

    const updatedCounts = {
      severeHeatwave: severeheatWave,
      heatWave: heatWave,
      normal: normal,
      count: severeheatWave + heatWave + normal,
      accuracy: this.overallAccuracy,
      // timeStamp: groupName
    };
    const updatedCountsForDistrict = {
      severeHeatwave: severeheatWaveforDistrict,
      heatWave: heatWaveforDistrict,
      normal: normalforDistrict,
      count: severeheatWaveforDistrict + heatWaveforDistrict + normalforDistrict,
      accuracy: this.overallAccuracy,
      // timeStamp: groupName
    };
    locWiseCountMap['BLOCK'] = updatedCounts
    locWiseCountMap['DISTRICT'] = updatedCountsForDistrict
    this.utilsSrv.heatwaveMetaData.next(locWiseCountMap);
  }
}
